import React, { useEffect, useRef } from "react";
import Modal from "react-modal";

const MenuStepFormModal = ({
  isOpen,
  onClose,
  steps,
  currentStep,
  onNext,
  onBack,
  onSubmit,
  isPending,
}) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (isOpen && scrollRef.current) {
      scrollRef.current.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [isOpen, currentStep]); // also resets when step changes

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="MultiStepFormModal"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          maxWidth: "1200px",
          width: "90%",
          margin: "auto",
          padding: "0",
          borderRadius: "12px",
          maxHeight: "90vh",
          overflow: "hidden",
        },
      }}
    >
      <div className="flex flex-col justify-between h-full">
        {/* ✅ THIS is the scrollable container */}
        <div ref={scrollRef} className="overflow-y-auto">
          <div className="sticky top-0 bg-white flex justify-between items-center gap-4 border-b border-gray-200 p-4 z-10">
            <h2 className="font-bold uppercase text-2xl mb-0">
              {steps[currentStep].title}
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              ✖
            </button>
          </div>

          {/* Progress Steps */}
          <div className="flex items-center justify-center gap-6 stepFormTitles py-4 mb-8 bg-gray-50">
            {steps.map((step, index) => (
              <div key={index} className="flex items-center gap-2">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center ${
                    index <= currentStep
                      ? "bg-primary text-white"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  {index + 1}
                </div>
                <span
                  className={`font-medium ${
                    index === currentStep ? "text-primary" : "text-gray-500"
                  }`}
                >
                  {step.title}
                </span>
              </div>
            ))}
          </div>

          <div className="p-4">{steps[currentStep].content}</div>
        </div>

        <div className="sticky bottom-0 bg-white border-t border-gray-200">
          <div className="flex justify-between items-center gap-4 p-4">
            {currentStep > 0 ? (
              <button
                className="px-6 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
                onClick={onBack}
              >
                Back
              </button>
            ) : (
              <button
                className="px-6 py-3 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors"
                onClick={onClose}
              >
                Cancel
              </button>
            )}

            <div className="flex gap-3">
              {currentStep < steps.length - 1 ? (
                <button
                  className="px-8 py-3 bg-primary hover:bg-primaryDark text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                  onClick={onNext}
                  disabled={isPending}
                >
                  Next
                </button>
              ) : (
                <button
                  className="px-8 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                  onClick={onSubmit}
                  disabled={isPending}
                >
                  {isPending ? "Processing..." : "Finish & Submit"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MenuStepFormModal;
